import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { ActivatedRoute, Router } from '@angular/router';

import { SnackbarService } from '@services/snackbar/snackbar.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { FormDirective } from '../../../directives/form/form.directive';
import { CustomerService } from '@services/customers/customer.service';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { FormComponent } from '../../../components/default-form/form.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-customer-edit',
    templateUrl: './customer-edit.component.html',
    styleUrls: ['./customer-edit.component.scss'],
    providers: [CustomerService, ImportService, ImportTypeService],
    standalone: false
})
export class CustomerEditComponent implements OnInit {

  public title = 'Edit Customer';
  public subtitle = '';

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;
  options = { hideFields: false };

  public pageActions: PageAction[];

  customer: Models.Customer;

  customerId: string;
  customerImportIds = [];

  selectedId: false;

  isLoading = false;

  public columnsImportType = [
    { prop: 'title' }
  ];
  public columnsImport = [
    { prop: 'title' },
    { validate: '_id', name: 'Imported', icon: 'check_box' }
  ];
  public paramsImport: any;

  showImportTable = false;
  showDetail = false;

  constructor(
    public customerService: CustomerService,
    public importService: ImportService,
    public importTypeService: ImportTypeService,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    if (this.route.snapshot.params['id']) {
      this.customerId = this.route.snapshot.params['id'];
      this.initExisting();
    } else {
      this.initNew();
    }
    this.createPageActions();
  }

  onSave() {
    return this.customer.validate(true).then(result => {
      if (result.success) {
        if (this.customerId) {
          this.customerService.patch(this.customerId, this.customer).then(customerResult => {
            this.snackbar.success('Saved changes successfull');
          });
        } else {
          this.customerService.create(this.customer).then(customerResult => {
            this.afterSave(customerResult);
            this.snackbar.success('Saved new entry successfull');
          });
        }
      } else {
        console.log(result);
        this.snackbar.open('Could not create the Customer, please fill in the form correctly');
      }
    });
  }

  public onCustomImportType(event: DataTableEvent) {
    // todo reset skip to zero, on change of importType
    if (this.selectedId === event.row._id) {
      this.selectedId = false;
      this.paramsImport = {};
    } else {
      this.selectedId = event.row._id;
      this.paramsImport = { typeId: event.row._id };
    }

  }

  public onCustomImport(event: DataTableEvent) {
    const index = this.customerImportIds.indexOf(event.row._id);

    if (index > -1) {
      this.customerImportIds.splice(index, 1);
    } else {
      this.customerImportIds.push(event.row._id);
    }
    this.customer.importIds = this.customerImportIds;
  }

  private initExisting() {
    this.customerService.get(this.customerId).then(customer => {
      this.customer = customer;
      this.title = 'Edit Customer: ' + this.customer.ibexCustomerId + ', ' + this.customer.company;
      if (!!this.customer.importIds) {
        this.customerImportIds = this.customer.importIds;
      }
      this.loadForm();
    });
  }

  private initNew() {
    this.isLoading = false;
    this.customer = <Models.Customer>Models.ModelFactory.createModelInstanceByName('Customer');
    this.loadForm();
  }

  private loadForm() {
    const formItem = DefaultFormComponent;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.customer;
    (<FormComponent>componentRef.instance).options = this.options;
    this.isLoading = false;
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Overview',
        callback: () => {
          this.router.navigate(['customers']);
        }
      })
    ];
    if (this.customerId) {
      this.pageActions.push(
        new PageAction({
          icon: 'person',
          title: 'Detail View Customer',
          callback: () => {
            this.router.navigate(['customers/', this.customerId]);
          }
        })
      );
    }
  }

  private afterSave(customer) {
    this.customerId = customer._id;
    this.initExisting();
  }

}
